import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { useShowAlert } from 'hooks';
import { createSendoutNote, updateSendoutNote } from 'services/Sendouts';
import strings from 'strings';
import { FPActionButton, TextBox, When } from 'UI/components/atoms';

import { SendoutNoteContainer } from './SendoutNoteForm.styled';

const COPIES = strings.sendoutsV2.drawers.tabs.notes;

export const SendoutNoteForm = ({
  description: originalDescription = '',
  noteId,
  onCancel,
  onFinishSave,
  sendoutId,
  title
}) => {
  const { showAlert } = useShowAlert();
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState(originalDescription);
  const trimmedDescription = description.trim();

  const handleChangeDescription = (_, value) => {
    setDescription(value);
  };

  const handleClickSave = async () => {
    try {
      setIsSaving(true);
      const body = {
        description: trimmedDescription
      };

      noteId
        ? await updateSendoutNote(sendoutId, noteId, body)
        : await createSendoutNote(sendoutId, body);

      showAlert({
        title: COPIES.alerts.title,
        body: noteId ? COPIES.alerts.updated : COPIES.alerts.created
      });
      setIsSaving(false);
      onFinishSave && onFinishSave();
    } catch (error) {
      setIsSaving(false);
      showAlert({
        title: COPIES.alerts.title,
        error
      });
    }
  };

  const handleClickCancel = () => {
    setDescription('');
    onCancel && onCancel();
  };

  return (
    <SendoutNoteContainer>
      <When condition={title}>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
      </When>

      <TextBox
        disabled={isSaving}
        fullWidth
        label=""
        multiline
        name="description"
        noMargin
        onChange={handleChangeDescription}
        placeholder={COPIES.placeholder}
        required
        value={description}
      />

      <Box display="flex" justifyContent="flex-end" gridGap={16} mt={2}>
        <FPActionButton
          disabled={isSaving}
          onClick={handleClickCancel}
          text={strings.shared.ui.cancel}
          variant="text"
        />
        <FPActionButton
          disabled={!trimmedDescription || isSaving}
          onClick={handleClickSave}
          startIcon={isSaving ? <CircularProgress color="inherit" size={20} /> : undefined}
          text={isSaving ? strings.shared.ui.saving : strings.shared.ui.save}
          variant="outlined"
        />
      </Box>
    </SendoutNoteContainer>
  );
};
